module.exports = __webpack_public_path__ + "media/images/doodle-old-f3b931b2bad60bd983e7ae738b878a02.PNG";